import React, { useRef, useState } from 'react'
import Location from 'react-autosuggest'
import debounce from 'lodash/debounce'
import axios from '../../../Axios'
import { Urls } from '../../../Urls'
import styled from 'styled-components';
import { withRouter } from 'react-router-dom'
const classNames = {
  container: 'react-autosuggest__container',
  input: 'react-autosuggest__input',
  inputFocused: 'react-autosuggest__input--focused',
  inputOpen: 'react-autosuggest__input--open',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted'
};
const AutoSuggestWrapper = styled.div.attrs(classNames)`
  ${classNames.container} {
    position: absolute;
  }
  .${classNames.input} {
    width: 100%;
    height: 30px;
    padding: 10px 20px;
    font-weight: 300;
    font-size: 16px;
    border:none
  }
  .${classNames.inputFocused} {
    outline: none;
  }
  .${classNames.inputOpen} {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .${classNames.suggestionsContainer} {
    display: none;
  }
  .${classNames.suggestionsContainerOpen} {
    display: block;
    position: absolute;
    top: 51px;
    border: 1px solid #aaa;
    background-color: #fff;
    font-weight: 300;
    font-size: 12px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    max-height: 100px;
    overflow-y: scroll;
    z-index: 2;
    height: auto;
    white-space: nowrap;
    width:100%
  }
  .${classNames.suggestionsList} {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  .${classNames.suggestion} {
    cursor: pointer;
    padding: 3px 5px;
  }
  .${classNames.suggestionHighlighted} {
    background-color: #ddd;
  }
`;
const AutoComplete = ({
  onSelect,
  // className,
  placeholder,
  onChange,
  value = '',
  key,
  // deafultSuggestion = { transporter_name: 'ALL' },
  // country = "INDIA",
  getResults,
  // searchFields = 'transporter_name',
 

}) => {
  const [suggestions, setSuggestions] = useState([])
  const [show, setShow] = useState(false)
  const abortControllerRef = useRef(null)

  const getWithCancel = (url) => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort()
    }
    const controller = new AbortController()
    abortControllerRef.current = controller
    return axios.get(url, { signal: controller.signal })
  }

  const onSuggestionsFetchRequested = debounce(async ({ value }) => {
    if (value.length < 3) return

    setShow(true)
    try {
      let url = `${Urls.Autocomplete.Get.getlist}?suggest=${value}&limit=20&searchFields=new_locations`
      let res = await getWithCancel(url)
      setSuggestions([])

      if (res.data.value.length < 1) {
        url = `${Urls.Autocomplete.Get.getlist}?suggest=${value}&limit=20&searchFields=transporter_name`
        res = await getWithCancel(url)

        if (res.data.value.length < 10) {
          url = `${Urls.Autocomplete.Get.getlist}?suggest=${value}&limit=20&searchFields=truck`
          res = await getWithCancel(url)

          const temp = []
          res.data.map(r => {
            if (r.name.includes(value)) {
              r.name = value.split(r.name) + ' ' + r.name
              temp.push(r)
            }
            else {
              r.name = value + ' ' + r.name
              temp.push(r)
            }
          })
          setSuggestions([{ name: value }, ...temp])
        }
        else {
          setSuggestions(res.data.value)
        }
      }
      else {
        setSuggestions(res.data.value)
      }

      setShow(false)
    } catch (err) {
      if (!axios.isCancel(err)) {
        setShow(false)
      }
    }
  }, 500)
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  }
  const getSuggestionValue = (value) => {
    return value.transporter_name ? value.transporter_name : value.name ? value.name : value.location_name;
  }
  const renderSuggestion = (value) => {
    return value.transporter_name ? value.transporter_name : value.name ? value.name : value.location_name;
  }
  const onSuggestionSelected = (event,
    { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }
  ) => {
    // console.log(suggestion)
    onChange(suggestion.transporter_name ? suggestion.transporter_name : suggestion.name ? suggestion.name : suggestion.location_name)
    onSelect(suggestion.transporter_name ? suggestion.transporter_name : suggestion.name ? suggestion.name : suggestion.location_name)
    if (getResults)
      // getResults(suggestion.transporter_name ? suggestion.transporter_name : suggestion.location_name);
      getResults(suggestion);



  }
  // const shouldRenderSuggestions = (value) => {
  //   return value.trim().length % 3 === 0
  // }

  const inputProps = {
    value: value,
    onChange: e => onChange(e.target.value),
    placeholder: placeholder,
    key: key,
    id: 'Autosuggets_Input_id',


  }
  return (
    <AutoSuggestWrapper>
      <Location
        suggestions={suggestions}
        onSuggestionsFetchRequested={value => onSuggestionsFetchRequested(value)}
        onSuggestionsClearRequested={e => onSuggestionsClearRequested()}
        getSuggestionValue={value => getSuggestionValue(value)}
        renderSuggestion={value => renderSuggestion(value)}
        onSuggestionSelected={onSuggestionSelected}
        inputProps={inputProps}
        theme={classNames}

      />
      {show ? <i className="fa fa-spinner fa-spin" style={{ position: 'absolute', right: '5%', top: '0%' }} /> : null}


    </AutoSuggestWrapper>

  )
}


export default withRouter(AutoComplete)
